<app-default-header></app-default-header>
<div class="garantieregeling d-flex">
  <div class="logos-container">
    <img src="assets/img/logo.png" alt="App Logo" class="logo me-3">
    <img src="assets/img/logo-garant-HQ.avif" alt="Garant Logo" class="logo" >
  </div>
  <div class="content">
    <h1>A guarantee in place: STO Garant</h1>
    <p>
      In order to meet its statutory obligation to provide a guarantee, BookATravel uses STO
      Garant, a guarantee scheme recognised by the Netherlands Authority for Consumers and Markets
      (ACM). You can check that this is the case by visiting STO Garant’s website and verifying that the
      organisation is listed as a participant (<a href="https://www.sto-garant.nl/en/members" target="_blank">www.sto-garant.nl/en/members</a>). You can find all
      information relating to STO Garant at <a href="https://www.sto-garant.nl/en" target="_blank">www.sto-garant.nl/en</a>.
    </p>
    <p>
      Whether STO Garant's guarantee applies to a particular (travel) offer made by BookATravel is
      specified for that offer. The Guarantee Scheme specifies what the guarantee covers and which
      conditions apply. You can find the Guarantee Scheme on STO Garant's website (<a href="https://www.sto-garant.nl/en/downloads" target="_blank">www.sto-garant.nl/en/downloads</a>).
    </p>
    <h2>How it works</h2>
    <p>
      If STO Garant's guarantee applies to your booking, you do not pay the booking amount to
      BookATravel but instead into the escrow account belonging to Stichting Derdengelden Certo
      Escrow, a payment services provider registered with De Nederlandsche Bank (DNB) and the
      Dutch Authority for the Financial Markets (AFM). This trust account holds your payment in reserve
      until the trip booked has come to an end. The booking amount is then released to BookATravel on the day after your trip ends. If BookATravel should become financially insolvent
      before the end of your trip, STO Garant will implement the guarantee. The Guarantee Scheme
      details how you can make a claim under the guarantee in such cases.
    </p>
  </div>
</div>
<app-footer></app-footer>